import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import StripeCard from '@accounting/components/payments/stripe/stripe-card.vue';

@Component({
  name: 'bpc-stripe-payment-modal',
  components: {
    'bpc-stripe-card': StripeCard,
  },
})
export default class StripePaymentModal extends Vue {
  $refs!: {
    stripeCard: InstanceType<typeof StripeCard> & { purchase() };
  };

  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'global.pay_with_credit_card' }) readonly modalTitle: string;
  @Prop({ type: Number, default: 0 }) readonly payAmount: number;
  @Prop({ type: String, default: 'card' }) readonly paymentMethodType: string;
  @Prop(Number) readonly invoiceId: number;

  key: number = 0;
  blockBtnPay: boolean = false;
  blockBtnCancel: boolean = false;
  loadingPayment: boolean = false;
  showAlert: boolean = false;
  alertVariant: string = 'null';
  alertMessage: string = '';
  stripeCardLoaded: boolean = false;
  paymentSuccess: boolean = false;
  stripePaymentData: object = {};

  get stripeActivated() {
    return this.$store.getters['centerSettings/stripeActivated'];
  }

  mounted() {
    if (!this.stripeActivated) {
      this.showAlertMessage('danger', 'global.stripe_is_not_active');
    } else if (!this.isValidPayAmount()) {
      this.blockBtnPay = true;
      this.showAlertMessage('danger', 'global.stripe_enough_amount');
    }
  }

  onMakePayment($event) {
    this.disableButtons(true);
    this.loadingPayment = true;
    this.hideAlertMessage();
    this.$emit('on-make-payment', $event);
  }

  async makePayment() {
    await this.$refs.stripeCard.purchase();
  }

  onWarningPayment($event) {
    this.showAlertMessage('danger', $event.message);
    this.disableButtons(false);
    this.loadingPayment = false;
  }

  onErrorPayment($event) {
    this.key++;
    this.showAlertMessage('danger', $event.message);
    this.disableButtons(false);
    this.loadingPayment = false;
  }

  onSuccessPayment($event) {
    this.paymentSuccess = true;
    this.blockBtnCancel = false;
    this.stripePaymentData = $event;
    this.showAlertMessage('success', 'global.stripe_payment_success');
    this.$emit('mark-as-paid', $event);
  }

  closePaymentSuccess() {
    this.$emit('on-success-payment', this.stripePaymentData);
  }

  disableButtons(value) {
    this.blockBtnPay = value;
    this.blockBtnCancel = value;
  }

  showAlertMessage(variant, message) {
    this.alertVariant = variant;
    this.alertMessage = message;
    this.showAlert = true;
  }

  showButtonsWhenNoAvailability() {
    this.blockBtnCancel = false;
    this.blockBtnPay = true;
    this.loadingPayment = false;
  }

  hideAlertMessage() {
    this.alertVariant = 'null';
    this.alertMessage = '';
    this.showAlert = false;
  }

  onStripeCardLoaded() {
    this.stripeCardLoaded = true;
  }

  close() {
    this.$emit('click-on-close');
    this.hideAlertMessage();
  }

  cancelPayment() {
    this.$emit('click-on-cancel');
    this.hideAlertMessage();
  }

  isValidPayAmount() {
    return !(isNaN(this.payAmount) || this.payAmount <= 0);
  }
}
